import type { DateRange } from "@b2bportal/rbc-activities-api";
import { default as dayjs, type Dayjs } from "dayjs";
import { ACTIVITY_URL_PARAM_KEYS } from "../queryParams";

export const URL_DATE_FORMAT = "YYYY-MM-DD" as const;

type BuildSearchParamsArgs = {
  activityId?: string;
  dateRange: DateRange;
};

function defined<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

export const buildSearchParams = ({
  dateRange,
  activityId,
}: BuildSearchParamsArgs) => {
  const searchParams = new URLSearchParams(
    [
      activityId != null
        ? [ACTIVITY_URL_PARAM_KEYS.ACTIVITY_ID, activityId]
        : null,
      [ACTIVITY_URL_PARAM_KEYS.FROM_DATE, formatDateForUrl(dateRange?.from)],
      [ACTIVITY_URL_PARAM_KEYS.UNTIL_DATE, formatDateForUrl(dateRange?.until)],
    ].filter(defined)
  );
  return searchParams;
};

export const formatDateForUrl = (
  dateString?: string | Dayjs | null
): (string & WithFormat<typeof URL_DATE_FORMAT>) | "" =>
  dateString
    ? (dayjs(dateString).format(URL_DATE_FORMAT) as string &
        WithFormat<typeof URL_DATE_FORMAT>)
    : "";

export interface WithFormat<TFormat extends string> {
  __format: TFormat;
}
